import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { URLBuilder2mz8zkz4u9ray as URLBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { Companion_getInstance1pptfj8vjmgsz as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import { HeadersBuilder3h7sn3kkvu98m as HeadersBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import { EmptyContent_getInstance3hxw2ytgkcdf2 as EmptyContent_getInstance } from '../utils/Content.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { get_BodyTypeAttributeKey1jqpsdtzeru4e as get_BodyTypeAttributeKey } from './RequestBody.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { OutgoingContent3t2ohmyam9o76 as OutgoingContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { takeFromkqlcz7c6dx2r as takeFrom } from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import { appendAlltwnjnu28pmtx as appendAll } from '../../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import {
  putAll10o0q8e6mgnzr as putAll,
  AttributeKey3aq8ytwgx54f7 as AttributeKey,
} from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { get_ENGINE_CAPABILITIES_KEYr1fjz8liznxo as get_ENGINE_CAPABILITIES_KEY } from '../engine/HttpClientEngineCapability.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { GMTDate36bhedawynxlf as GMTDate } from '../../../../../ktor-ktor-utils/io/ktor/util/date/DateJs.mjs';
import { ClientUpgradeContent299vg0lx1tyfp as ClientUpgradeContent } from './ClientUpgradeContent.mjs';
import { takeFrom3rd40szpqy350 as takeFrom_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ResponseAdapterAttributeKey() {
  _init_properties_HttpRequest_kt__813lx1();
  return ResponseAdapterAttributeKey;
}
var ResponseAdapterAttributeKey;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function HttpRequestBuilder$setCapability$lambda() {
  // Inline function 'kotlin.collections.mutableMapOf' call
  return LinkedHashMap().ec();
}
var HttpRequestBuilderClass;
function HttpRequestBuilder() {
  if (HttpRequestBuilderClass === VOID) {
    class $ {
      constructor() {
        this.w5h_1 = new (URLBuilder())();
        this.x5h_1 = Companion_getInstance().v51_1;
        this.y5h_1 = new (HeadersBuilder())();
        this.z5h_1 = EmptyContent_getInstance();
        this.a5i_1 = SupervisorJob();
        this.b5i_1 = AttributesJsFn(true);
      }
      u51() {
        return this.y5h_1;
      }
      p5l(value) {
        if (!(value == null)) {
          this.b5i_1.i4n(get_BodyTypeAttributeKey(), value);
        } else {
          this.b5i_1.k4n(get_BodyTypeAttributeKey());
        }
      }
      x5s() {
        return this.b5i_1.g4n(get_BodyTypeAttributeKey());
      }
      g5u(block) {
        return block(this.w5h_1, this.w5h_1);
      }
      i37() {
        var tmp = this.w5h_1.i37();
        var tmp_0 = this.x5h_1;
        var tmp_1 = this.y5h_1.i37();
        var tmp_2 = this.z5h_1;
        var tmp0_elvis_lhs = tmp_2 instanceof OutgoingContent() ? tmp_2 : null;
        var tmp_3;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No request transformation found: ' + toString(this.z5h_1);
          throw IllegalStateException().o(toString(message));
        } else {
          tmp_3 = tmp0_elvis_lhs;
        }
        return new (HttpRequestData())(tmp, tmp_0, tmp_1, tmp_3, this.a5i_1, this.b5i_1);
      }
      o5l(builder) {
        this.a5i_1 = builder.a5i_1;
        return this.s5q(builder);
      }
      s5q(builder) {
        this.x5h_1 = builder.x5h_1;
        this.z5h_1 = builder.z5h_1;
        this.p5l(builder.x5s());
        takeFrom(this.w5h_1, builder.w5h_1);
        this.w5h_1.f55_1 = this.w5h_1.f55_1;
        appendAll(this.y5h_1, builder.y5h_1);
        putAll(this.b5i_1, builder.b5i_1);
        return this;
      }
      g5s(key, capability) {
        var tmp = get_ENGINE_CAPABILITIES_KEY();
        var capabilities = this.b5i_1.l4n(tmp, HttpRequestBuilder$setCapability$lambda);
        // Inline function 'kotlin.collections.set' call
        capabilities.x4(key, capability);
      }
      t5r(key) {
        var tmp0_safe_receiver = this.b5i_1.g4n(get_ENGINE_CAPABILITIES_KEY());
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u4(key);
      }
    }
    initMetadataForClass($, 'HttpRequestBuilder', HttpRequestBuilder);
    HttpRequestBuilderClass = $;
  }
  return HttpRequestBuilderClass;
}
function get_coroutineContext() {
  return this.u5i().bw();
}
var HttpRequestClass;
function HttpRequest() {
  if (HttpRequestClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HttpRequest');
    HttpRequestClass = $;
  }
  return HttpRequestClass;
}
var HttpRequestDataClass;
function HttpRequestData() {
  if (HttpRequestDataClass === VOID) {
    class $ {
      constructor(url, method, headers, body, executionContext, attributes) {
        this.g5l_1 = url;
        this.h5l_1 = method;
        this.i5l_1 = headers;
        this.j5l_1 = body;
        this.k5l_1 = executionContext;
        this.l5l_1 = attributes;
        var tmp = this;
        var tmp0_safe_receiver = this.l5l_1.g4n(get_ENGINE_CAPABILITIES_KEY());
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v4();
        tmp.m5l_1 = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
      }
      toString() {
        return 'HttpRequestData(url=' + this.g5l_1.toString() + ', method=' + this.h5l_1.toString() + ')';
      }
    }
    initMetadataForClass($, 'HttpRequestData');
    HttpRequestDataClass = $;
  }
  return HttpRequestDataClass;
}
var HttpResponseDataClass;
function HttpResponseData() {
  if (HttpResponseDataClass === VOID) {
    class $ {
      constructor(statusCode, requestTime, headers, version, body, callContext) {
        this.j5j_1 = statusCode;
        this.k5j_1 = requestTime;
        this.l5j_1 = headers;
        this.m5j_1 = version;
        this.n5j_1 = body;
        this.o5j_1 = callContext;
        this.p5j_1 = GMTDate();
      }
      toString() {
        return 'HttpResponseData=(statusCode=' + this.j5j_1.toString() + ')';
      }
    }
    initMetadataForClass($, 'HttpResponseData');
    HttpResponseDataClass = $;
  }
  return HttpResponseDataClass;
}
var ResponseAdapterClass;
function ResponseAdapter() {
  if (ResponseAdapterClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ResponseAdapter');
    ResponseAdapterClass = $;
  }
  return ResponseAdapterClass;
}
function isUpgradeRequest(_this__u8e3s4) {
  _init_properties_HttpRequest_kt__813lx1();
  var tmp = _this__u8e3s4.j5l_1;
  return tmp instanceof ClientUpgradeContent();
}
function headers(_this__u8e3s4, block) {
  _init_properties_HttpRequest_kt__813lx1();
  // Inline function 'kotlin.apply' call
  var this_0 = _this__u8e3s4.u51();
  block(this_0);
  return this_0;
}
function url(_this__u8e3s4, urlString) {
  _init_properties_HttpRequest_kt__813lx1();
  takeFrom_0(_this__u8e3s4.w5h_1, urlString);
}
var properties_initialized_HttpRequest_kt_zh09pz;
function _init_properties_HttpRequest_kt__813lx1() {
  if (!properties_initialized_HttpRequest_kt_zh09pz) {
    properties_initialized_HttpRequest_kt_zh09pz = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ResponseAdapterAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(ResponseAdapter());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(ResponseAdapter()), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$2);
    ResponseAdapterAttributeKey = new (AttributeKey())(name, tmp$ret$1);
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  get_coroutineContext as get_coroutineContext1djaai1ellg0c,
  HttpRequestBuilder as HttpRequestBuilder15f2nnx9sjuv1,
  HttpRequest as HttpRequest3fsc4149kgwfg,
  HttpResponseData as HttpResponseData2dozo5khuplr6,
  get_ResponseAdapterAttributeKey as get_ResponseAdapterAttributeKey1ll13ywinsgvd,
  headers as headers24pki7ce1busg,
  isUpgradeRequest as isUpgradeRequest3msdo2i9hxs68,
  url as url2l6iw5ri21nxb,
};
//endregion

//# sourceMappingURL=HttpRequest.mjs.map
